//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: 'á¡',
            2: 'á¢',
            3: 'á£',
            4: 'á¤',
            5: 'á¥',
            6: 'á¦',
            7: 'á§',
            8: 'á¨',
            9: 'á©',
            0: 'á ',
        },
        numberMap = {
            'á¡': '1',
            'á¢': '2',
            'á£': '3',
            'á¤': '4',
            'á¥': '5',
            'á¦': '6',
            'á§': '7',
            'á¨': '8',
            'á©': '9',
            'á ': '0',
        };

    var km = moment.defineLocale('km', {
        months: 'áááá¶_áá»áááá_áá¸áá¶_áááá¶_á§ááá¶_áá·áá»áá¶_áááááá¶_áá¸á á¶_ááááá¶_áá»áá¶_áá·áááá·áá¶_áááá¼'.split(
            '_'
        ),
        monthsShort:
            'áááá¶_áá»áááá_áá¸áá¶_áááá¶_á§ááá¶_áá·áá»áá¶_áááááá¶_áá¸á á¶_ááááá¶_áá»áá¶_áá·áááá·áá¶_áááá¼'.split(
                '_'
            ),
        weekdays: 'á¢á¶áá·ááá_ááááá_á¢áááá¶á_áá»á_áááá ááááá·á_áá»ááá_áááá'.split('_'),
        weekdaysShort: 'á¢á¶_á_á¢_á_ááá_áá»_á'.split('_'),
        weekdaysMin: 'á¢á¶_á_á¢_á_ááá_áá»_á'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /áááá¹á|áááá¶á/,
        isPM: function (input) {
            return input === 'áááá¶á';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'áááá¹á';
            } else {
                return 'áááá¶á';
            }
        },
        calendar: {
            sameDay: '[ááááááá áááá] LT',
            nextDay: '[ááá¢áá áááá] LT',
            nextWeek: 'dddd [áááá] LT',
            lastDay: '[áááá·ááá·á áááá] LT',
            lastWeek: 'dddd [ááááá¶á ááá»á] [áááá] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sááá',
            past: '%sáá»á',
            s: 'ááá»áááá¶ááá·áá¶áá¸',
            ss: '%d áá·áá¶áá¸',
            m: 'áá½ááá¶áá¸',
            mm: '%d áá¶áá¸',
            h: 'áá½ááááá',
            hh: '%d áááá',
            d: 'áá½ááááá',
            dd: '%d áááá',
            M: 'áá½ááá',
            MM: '%d áá',
            y: 'áá½ááááá¶á',
            yy: '%d áááá¶á',
        },
        dayOfMonthOrdinalParse: /áá¸\d{1,2}/,
        ordinal: 'áá¸%d',
        preparse: function (string) {
            return string.replace(/[á¡á¢á£á¤á¥á¦á§á¨á©á ]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return km;

})));
